'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import styles from './MerchantsTravellersDestination.module.css';

export default function MerchantsTravellersDestination({
  selectedMarket,
}: {
  selectedMarket: 'es' | 'it';
}) {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.travellersDestinationSection}>
      <div className={styles.backgroundContainer}>
        <div className={styles.contentContainer}>
          <div className={styles.content}>
            <h2 className={styles.heading} suppressHydrationWarning>{t('merchants.travellersDestination.heading')}</h2>
            <p className={styles.subheading} suppressHydrationWarning>{t('merchants.travellersDestination.subheading')}</p>
          </div>
          <a
            href={
              selectedMarket === 'it'
                ? 'https://signup.stampit.co/'
                : 'https://sales.askforstamp.com/signup'
            }
            target="_blank"
            className={styles.ctaButton}
            suppressHydrationWarning
          >
            {t('merchants.travellersDestination.ctaText')}
          </a>
        </div>
      </div>
    </section>
  );
}
